import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../Store";
import { useCallback } from "react";
import {
  Actions,
  AUTHENTICATED,
  LOGIN,
  LOGOUT,
  State,
  UNAUTHENTICATED,
} from "./Types";

export const useAuth = () => useSelector((state: AppState) => state.auth);

export const useLogin = () => {
  const dispatch = useDispatch();
  return useCallback(
    (api_key: string) =>
      dispatch({
        type: LOGIN,
        api_key,
      }),
    [dispatch],
  );
};

const STORAGE_KEY = "auth:api_key";

function initial(): State {
  const api_key = localStorage.getItem(STORAGE_KEY);
  if (api_key) {
    return {
      type: AUTHENTICATED,
      api_key,
    };
  }
  return {
    type: UNAUTHENTICATED,
  };
}

export const Reducer = (state: State = initial(), action: Actions): State => {
  switch (action.type) {
    case LOGIN:
      localStorage.setItem(STORAGE_KEY, action.api_key);
      return {
        type: AUTHENTICATED,
        api_key: action.api_key,
      };
    case LOGOUT:
      localStorage.removeItem(STORAGE_KEY);
      return {
        type: UNAUTHENTICATED,
      };
    default:
      return state;
  }
};
